import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-info-text',
  template: `
    <div [class]="'info-text-container_' + type">
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./info-text.component.scss']
})
export class InfoTextComponent {
  @Input() type: 'default' | 'alarm' | 'warning' | 'success' | string = 'default';
}
